import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import Billing from './Billing/Billing';


const BillingPicker = ({ resource }) => {
  const {
    householdResource,
  } = useSimpleHousehold();
  return pick(resource, {
    [fr.relationships.householdSectionMember.name]: null,
  }, (
    <Billing
      householdResource={householdResource}
    />
  ));
};

BillingPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
BillingPicker.defaultProps = {};

export default BillingPicker;
